export interface RateableMessage {
  id: string
  turnType: "user" | "assistant"
  messageType?: string
}

export function computeRateableMessageIds(
  messages: RateableMessage[],
  isStreaming: boolean,
): Set<string> {
  const rateable = new Set<string>()
  let candidate: string | null = null
  for (const message of messages) {
    if (message.turnType === "user") {
      if (candidate) rateable.add(candidate)
      candidate = null
    } else if (message.messageType === "text" && message.id) {
      candidate = message.id
    }
  }
  if (candidate) rateable.add(candidate)
  if (isStreaming && candidate) rateable.delete(candidate)
  return rateable
}
